<template>
  <div class="admin">
    <main-layout>
      <b-container fluid>
        <b-row>
          <b-col class="p-0">
            <div class="dashboard">
              <sidebar :showSidebar="showSidebar" v-on:toggleSidebar="toggleSidebar($event)">
                <sidebar-link title="Forside" icon="house" link="/administration"></sidebar-link>
                <sidebar-link title="Statistik" icon="pie-chart" href="./admin/request/request/overview/"></sidebar-link>
                <sidebar-link title="Rapportering" icon="table" link="/administration/reporting"></sidebar-link>
                <sidebar-link title="Indholdssektioner" icon="card-text" link="/administration/content"></sidebar-link>
                <sidebar-link title="Taksonomi" icon="tags" link="/administration/keywords"></sidebar-link>
                <sidebar-link title="Brugere" icon="people" href="./admin/auth/"></sidebar-link>
                <sidebar-link title="Nyhedsbrev" icon="mailbox" link="/administration/newsletter"></sidebar-link>
              </sidebar>
              <content-fit-sidebar :showSidebar="showSidebar" :fluid="fluid">
                <router-view v-on:setFluid="fluid = $event" />
              </content-fit-sidebar>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import Sidebar from '@/components/Sidebar.vue'
import ContentFitSidebar from '@/components/ContentFitSidebar.vue'
import SidebarLink from '@/components/SidebarLink.vue'
export default {
  name: 'Dashboard',
  components: { MainLayout, Sidebar, ContentFitSidebar, SidebarLink },
  data: () => ({
    showSidebar: false,
    fluid: 'md'
  }),
  methods: {
    toggleSidebar(value) {
      this.showSidebar = value
    }
  },
  created () {
    const user = sessionStorage.getItem('user')
    if (user) {
      this.$store.commit('SET_USER_DATA', JSON.parse(user))
    }
  },
}
</script>

<style>

</style>